import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export const OrchestratorViewMode = {
	chart: 1,
	table: 2
} as const;

export type OrchestratorViewModeType = (typeof OrchestratorViewMode)[keyof typeof OrchestratorViewMode];

export type RxIntuitiveTeethOrchestratorState = {
	viewMode: OrchestratorViewModeType;
};

const createInitialState = (): RxIntuitiveTeethOrchestratorState => ({
	viewMode: OrchestratorViewMode.chart
});

@Injectable()
@StoreConfig({ name: 'rx-intuitive-teeth-orchestrator', resettable: true })
export class RxIntuitiveTeethOrchestratorStore extends Store<RxIntuitiveTeethOrchestratorState> {
	constructor() {
		super(createInitialState());
	}

	changeViewMode(newViewMode: OrchestratorViewModeType) {
		this.update({ viewMode: newViewMode });
	}
}
